import { useAtomCallback } from 'jotai/utils';
import { useCallback, useEffect, useState } from 'react';
import { useSaveCompanyData, useSaveCompanyDataJ } from '../../../services/hooks/useSaveCompanyData';
import { fetchListItems } from '../../../services/queries/MaggieListQueries';
import { companyListStateJ } from '../../../services/state/ListsStateJ';

export function usePrepItemsData(listId: number | null) {
  const { batchSaveCompanyData } = useSaveCompanyData();
  const saveCompanyDataJ = useSaveCompanyDataJ();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState('');

  const saveCompanyData = useAtomCallback(
    useCallback(
      async (_get, set) => {
        if (!listId) {
          return;
        }

        try {
          const list = await fetchListItems(listId);
          set(companyListStateJ(listId), list);
          batchSaveCompanyData(list.companies);
          saveCompanyDataJ(list.companies);
          setReady(true);
        } catch (err) {
          console.error(err);
          setError("Couldn't fetch list items");
        }
      },
      [batchSaveCompanyData, listId, saveCompanyDataJ]
    )
  );

  useEffect(() => {
    // invalidate data whenever listId changes
    return () => {
      setReady(false);
      setError('');
    };
  }, [listId]);

  useEffect(() => {
    saveCompanyData();
  }, [saveCompanyData, listId]);

  return { ready, error };
}
